import { render } from "./Index.vue?vue&type=template&id=6bea8f3a&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=6bea8f3a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6bea8f3a"

export default script